import TextField from '@mui/material/TextField';
import { useDispatch } from 'react-redux';
import { useState, useEffect, ChangeEvent } from 'react';

// Converted to Tailwind classes

interface FormData {
  dataArmazenamentoInicio: string;
  temperaturaRecolha: string;
  descricaoRazao: string;
  observacoes: string;
}

export default function InformacoesAdicionais() {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState<FormData>({
    dataArmazenamentoInicio: '',
    temperaturaRecolha: '',
    descricaoRazao: '',
    observacoes: ''
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  useEffect(() => {
    dispatch({
      type: 'dadosAdicionais',
      payload: { dadosAdicionais: formData }
    });
  }, [formData, dispatch]);

  return (
    <div className="tw-p-4">
      <h2 className="tw-text-xl tw-font-medium tw-mb-6">INFORMAÇÕES ADICIONAIS</h2>

      {/* Primeira seção: Duração e condição de armazenamento */}
      <div className="tw-p-6 tw-mb-6 tw-bg-white tw-shadow">
        <h3 className="tw-text-lg tw-font-medium tw-mb-4">Duração e condição de armazenamento:</h3>

        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
          <div>
            <TextField
              type="date"
              label="Em stock desde a data de"
              fullWidth
              size="small"
              name="dataArmazenamentoInicio"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              onChange={handleChange}
              value={formData.dataArmazenamentoInicio}
            />
          </div>

          <div>
            <TextField
              type="text"
              label="Temperatura no momento da recolha"
              fullWidth
              size="small"
              name="temperaturaRecolha"
              variant="outlined"
              onChange={handleChange}
              value={formData.temperaturaRecolha}
            />
          </div>
        </div>
      </div>

      {/* Segunda seção: Descrição da razão do controlo de qualidade */}
      <div className="tw-p-6 tw-mb-6 tw-bg-white tw-shadow">
        <h3 className="tw-text-lg tw-font-medium tw-mb-4">Descrição da razão do controlo de qualidade</h3>

        <div className="">
          <TextField
            multiline
            rows={4}
            type="text"
            label="Descrição da razão do controlo de qualidade, das condições de armazenamento e de transporte do produto e descrição das embalagens"
            placeholder="Descreva detalhadamente..."
            fullWidth
            name="descricaoRazao"
            variant="outlined"
            onChange={handleChange}
            value={formData.descricaoRazao}
          />
          <div className="tw-text-right tw-text-sm tw-text-gray-600 tw-mt-1">{formData.descricaoRazao.length} caracteres</div>
        </div>
      </div>

      {/* Terceira seção: Observações */}
      <div className="tw-p-6 tw-mb-6 tw-bg-white tw-shadow">
        <h3 className="tw-text-lg tw-font-medium tw-mb-4">Observações</h3>

        <div>
          <TextField
            multiline
            rows={3}
            type="text"
            label="Outras observações"
            fullWidth
            name="observacoes"
            variant="outlined"
            onChange={handleChange}
            value={formData.observacoes}
          />
          <div className="tw-text-right tw-text-sm tw-text-gray-600 tw-mt-1">{formData.observacoes.length} caracteres</div>
        </div>
      </div>
    </div>
  );
}